import React, { useEffect, useState } from 'react';
import TaskForm from './TaskForm';
import '../../styles/TaskList.css';
import useApiStable from '../../utils/useApiStable';

function TaskList() {
  const [tasks, setTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState('');
  const api = useApiStable();

  const loadTasks = () => {
    setError('');
    api.get('/tasks')
      .then(data => setTasks(Array.isArray(data) ? data : []))
      .catch(err => setError(err.message || 'Fehler beim Laden der Aufgaben'));
  };

  useEffect(() => {
    loadTasks();
  }, []);

  const handleEdit = (task) => {
    setSelectedTask(task);
    setShowForm(true);
  };

  const handleCreate = () => {
    setSelectedTask(null);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setSelectedTask(null);
    loadTasks(); // einmaliger Reload reicht
  };

  return (
    <div className="tasklist-container">
      <div className="tasklist-header">
        <h2>Aufgaben</h2>
        <div>
          <button className="tasklist-btn" onClick={handleCreate}>Neue Aufgabe</button>
        </div>
      </div>
      {error && <div style={{color:'#c62828', fontSize:'0.85em', marginBottom:'8px'}}>{error}</div>}
      <ul className="tasklist-list">
        {tasks.map((task, idx) => (
          <li className="tasklist-item" key={task.id ?? `${task.title || 'task'}-${idx}`}>
            <div className="tasklist-item-info">
              <strong>{task.title}</strong> ({task.duration} min)<br />
              <span style={{color:'#666', fontSize:'0.95em'}}>Verantwortlich: {task.responsible?.name || '---'}</span>
            </div>
            <button className="tasklist-edit-btn" onClick={() => handleEdit(task)}>Bearbeiten</button>
          </li>
        ))}
      </ul>
      {showForm && (
        <TaskForm task={selectedTask} onClose={handleFormClose} />
      )}
    </div>
  );
}

export default TaskList;
